/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Whole_Alert_Flamingo_ListInputs */

const fr_whole_alert_flamingo_list = /** @type {(inputs: Whole_Alert_Flamingo_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter un programme / cours`)
};

/**

* @param {Whole_Alert_Flamingo_ListInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const whole_alert_flamingo_list = /** @type {((inputs?: Whole_Alert_Flamingo_ListInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Whole_Alert_Flamingo_ListInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_whole_alert_flamingo_list(inputs)
});